import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  forms: {}
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/tools/forms/index.js